import { NuxtAppOptions } from '@nuxt/types'
import { Capacitor } from '@capacitor/core'
import { version } from '../package.json'

export default function ({
  $axios,
  $device,
  store,
  app,
  $config: { baseURL },
}: NuxtAppOptions) {
  $axios.defaults.baseURL = baseURL

  $axios.defaults.headers.common.Device = Capacitor.isNativePlatform()
    ? 'mobileapp'
    : $device.isMobile
    ? 'mobile'
    : 'desktop'
  $axios.defaults.headers.common['X-API-Version'] = version
  $axios.defaults.headers.common['X-Host'] = store?.state.site.host
  if (app.context.req && app.context.req.headers.host) {
    $axios.defaults.headers.common['X-Host'] = app.context.req.headers.host
  }
}
